/* ==========================================================================
   Millennio — drawer «Recogida en tienda» de la PDP (#254)
   --------------------------------------------------------------------------
   Abre el dialogo de sedes desde la linea con icono de tienda que vive bajo el
   bloque de entrega. Una sola pieza para movil (hoja inferior) y escritorio
   (panel derecho): la posicion la decide el CSS por ancho, aqui solo se
   monta, se abre, se cierra y se cuida el foco.

   Convenciones que sigue, a proposito iguales a las del buscador:
   · Montaje a demanda con `esta-montado` (devuelve el display) y, tras un
     reflow sincrono, `esta-abierto` (corre la transicion). Cerrado, el drawer
     no existe para el layout.
   · Bloqueo de scroll con `window.miBloquearScroll` (mi-search.js): un solo
     motor de bloqueo en la tienda. Si no esta, se abre igual sin bloquear —
     nunca `overflow:hidden` en body: rompe la cabecera pegajosa.
   · El mapa incrustado (opcional por sede) se carga SOLO al primer open:
     `data-src` → `src`.
   · Delegado en `document`: sobrevive a que el editor repinte la seccion.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__miRecogida) return;
  window.__miRecogida = true;

  var abierto = null;      // el drawer abierto ahora, o null
  var origenFoco = null;   // a donde vuelve el foco al cerrar
  var temporizador = null;

  function enfocables(panel) {
    var lista = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), iframe');
    return Array.prototype.filter.call(lista, function (el) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
  }

  function cargarMapas(drawer) {
    drawer.querySelectorAll('iframe[data-src]').forEach(function (f) {
      f.src = f.getAttribute('data-src');
      f.removeAttribute('data-src');
    });
  }

  function abrir(drawer, origen) {
    if (abierto === drawer) return;
    if (abierto) cerrar(true);
    abierto = drawer;
    origenFoco = origen || document.activeElement;
    if (temporizador) { clearTimeout(temporizador); temporizador = null; }

    /* MEDIDO: el drawer nace dentro de la seccion, y esa rama lleva TRES
       contextos de apilamiento (la seccion a z:0, <main> a 3, un envoltorio a
       13) mientras la cabecera pegajosa vive en otra rama. Ningun z-index de
       dentro puede pasar por encima de ella. Se saca el dialogo a <body> la
       primera vez que se abre -donde viven el carrito y el buscador-: los
       estilos son globales y viajan con el; el id se conserva, asi que el
       `aria-controls` del disparador sigue apuntando bien. */
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);

    drawer.classList.add('esta-montado');
    void drawer.offsetWidth; // reflow: que la transicion arranque desde el estado cerrado
    drawer.classList.add('esta-abierto');
    cargarMapas(drawer);
    if (typeof window.miBloquearScroll === 'function') window.miBloquearScroll(true);

    var panel = drawer.querySelector('.mi-recogida__panel');
    var primero = enfocables(panel)[0];
    // El foco entra al PANEL (no al primer boton): la lectora anuncia el
    // titulo del dialogo antes que «Cerrar».
    (panel || primero) && (panel || primero).focus({ preventScroll: true });

    document.dispatchEvent(new CustomEvent('mi:recogida:abierto', { detail: { drawer: drawer } }));
  }

  function cerrar(inmediato) {
    var drawer = abierto;
    if (!drawer) return;
    abierto = null;
    drawer.classList.remove('esta-abierto');
    if (typeof window.miBloquearScroll === 'function') window.miBloquearScroll(false);

    var desmontar = function () {
      drawer.classList.remove('esta-montado');
      temporizador = null;
    };
    if (inmediato) desmontar(); else temporizador = setTimeout(desmontar, 380);

    if (origenFoco && typeof origenFoco.focus === 'function') origenFoco.focus({ preventScroll: true });
    origenFoco = null;
    document.dispatchEvent(new CustomEvent('mi:recogida:cerrado', { detail: { drawer: drawer } }));
  }

  document.addEventListener('click', function (e) {
    var disparador = e.target.closest && e.target.closest('[data-mi-recogida-abrir]');
    if (disparador) {
      e.preventDefault();
      var id = disparador.getAttribute('aria-controls');
      var drawer = (id && document.getElementById(id)) || document.querySelector('[data-mi-recogida]');
      if (drawer) abrir(drawer, disparador);
      return;
    }
    if (abierto && e.target.closest && e.target.closest('[data-mi-recogida-cerrar]')) {
      e.preventDefault();
      cerrar(false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!abierto) return;
    if (e.key === 'Escape') { e.preventDefault(); cerrar(false); return; }
    if (e.key !== 'Tab') return;
    // Atrapa-foco: Tab circula dentro del panel, en los dos sentidos.
    var lista = enfocables(abierto.querySelector('.mi-recogida__panel'));
    if (!lista.length) return;
    var primero = lista[0], ultimo = lista[lista.length - 1];
    if (e.shiftKey && (document.activeElement === primero || !abierto.contains(document.activeElement))) {
      e.preventDefault(); ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault(); primero.focus();
    }
  });

  // El editor repinta la seccion entera: si el drawer abierto desaparece del
  // DOM, se suelta el bloqueo para no dejar la pagina sin scroll.
  document.addEventListener('shopify:section:unload', function () {
    if (abierto && !document.body.contains(abierto)) {
      abierto = null;
      if (typeof window.miBloquearScroll === 'function') window.miBloquearScroll(false);
    }
  });

  // Y al repintar, la seccion trae un drawer NUEVO con el mismo id: el que se
  // habia movido a <body> queda huerfano y se retira, para que el disparador
  // no abra una copia con los datos de antes de la edicion.
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('body > [data-mi-recogida]').forEach(function (viejo) {
      var vivo = document.querySelector('.shopify-section [data-mi-recogida]#' + CSS.escape(viejo.id));
      if (vivo && vivo !== viejo) { if (abierto === viejo) cerrar(true); viejo.remove(); }
    });
  });
})();
